import { LoanOfficer } from "../../types"

export const convertLoToAutocompleteOption = (lo: LoanOfficer) => ({
  id: lo.uid,
  text: lo.name
})
